import { c as _c } from "react/compiler-runtime";
import type { Address, Hex } from 'viem';
import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/lib/orpc/client';
const EMPTY_VAULT_ADDRESSES: readonly Address[] = [];

/**
 * Fetches the Public Allocator V2 and its candidate vault addresses for a market.
 * `isPending` distinguishes unresolved discovery from a resolved empty candidate set.
 */
export function useMarketPublicAllocatorVaults(chainId, marketId, t0) {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  let t3;
  if ($[2] !== chainId || $[3] !== enabled || $[4] !== marketId) {
    t3 = orpc.market.publicAllocatorVaults.queryOptions({
      input: enabled && chainId != null && marketId != null ? {
        chainId,
        marketId
      } : skipToken,
      staleTime: 60000
    });
    $[2] = chainId;
    $[3] = enabled;
    $[4] = marketId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data,
    isPending,
    isLoading,
    error
  } = useQuery(t3);
  let t4;
  if ($[6] !== data?.vaults) {
    t4 = data?.vaults.map(_temp) ?? EMPTY_VAULT_ADDRESSES;
    $[6] = data?.vaults;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const vaultAddresses = t4;
  const t5 = data?.address;
  let t6;
  if ($[8] !== error || $[9] !== isLoading || $[10] !== isPending || $[11] !== t5 || $[12] !== vaultAddresses) {
    t6 = {
      publicAllocator: t5,
      vaultAddresses,
      isPending,
      isLoading,
      error
    };
    $[8] = error;
    $[9] = isLoading;
    $[10] = isPending;
    $[11] = t5;
    $[12] = vaultAddresses;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(vault) {
  return vault.address;
}